module.exports = __webpack_public_path__ + "static/rwl-ad289d09a22429ec1254739a416d68dd.jpg";